<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('finance-over-view')" v-if="permissionCodes.indexOf('013001000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-submenu index="2" v-if="permissionCodes.indexOf('013002000') !== -1 || permissionCodes.indexOf('013002009') !== -1 || permissionCodes.indexOf('013002015') !== -1">
        <template slot="title">
          <i class="el-icon-damai-wuyefeiyongchuzhang"></i>
          <span>租赁合约管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" @click="toNewRouter('rent-finance')" v-if="permissionCodes.indexOf('013002000') !== -1">租金账单</el-menu-item>
          <el-menu-item index="2-2" @click="toNewRouter('property-finance')" v-if="permissionCodes.indexOf('013002009') !== -1">物业费账单</el-menu-item>
          <el-menu-item index="2-3" @click="toNewRouter('deposit-finance')" v-if="permissionCodes.indexOf('013002015') !== -1">保证金及其他账单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="9" v-if="permissionCodes.indexOf('013003000') !== -1" >
        <template slot="title">
          <i class="el-icon-damai-hetong2"></i>
          <span>其他合约管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="9-1" @click="toNewRouter('other-rent-finance')" >账单管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="13" @click="toNewRouter('refund-bill-management')" v-if="permissionCodes.indexOf('013028000') !== -1">
        <i class="el-icon-damai-ic_tuizuzhangdanguanli"></i>
        <span slot="title">退租账单管理</span>
      </el-menu-item>
<!--      <el-submenu index="8" v-if="permissionCodes.indexOf('013002000') !== -1">-->
<!--        <template slot="title">-->
<!--          <i class="el-icon-damai-wuyefeiyongchuzhang"></i>-->
<!--          <span>其他合约管理</span>-->
<!--        </template>-->
<!--        <el-menu-item-group>-->
<!--          <el-menu-item index="8-1" @click="toNewRouter('rent-finance')" >租金账单</el-menu-item>-->
<!--          <el-menu-item index="8-2" @click="toNewRouter('property-finance')" >物业费账单</el-menu-item>-->
<!--          <el-menu-item index="8-3" @click="toNewRouter('deposit-finance')" >保证金及其他账单</el-menu-item>-->
<!--          <el-menu-item index="8-4" @click="toNewRouter('deposit-finance')" >收款记录</el-menu-item>-->
<!--        </el-menu-item-group>-->
<!--      </el-submenu>-->
<!--      <el-menu-item index="7" @click="toNewRouter('repair-finance-pay-record')" v-if="permissionCodes.indexOf('013004006') !== -1">-->
<!--        <i class="el-icon-damai-wj-bxd"></i>-->
<!--        <span slot="title">租赁合约收款记录</span>-->
<!--      </el-menu-item>-->
      <el-submenu index="3" v-if="permissionCodes.indexOf('013004000') !== -1 || permissionCodes.indexOf('013004004') !== -1 || permissionCodes.indexOf('013005000') !== -1 || permissionCodes.indexOf('013006000') !== -1 || permissionCodes.indexOf('013007000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_diankongguanli"></i>
          <span>电控管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="3-1" @click="toNewRouter('electronic-finance-bill')" v-if="permissionCodes.indexOf('013004000') !== -1 || permissionCodes.indexOf('013004004') !== -1">账单管理</el-menu-item>
          <el-menu-item index="3-2" @click="toNewRouter('electronic-finance-rent-record')" v-if="permissionCodes.indexOf('013005000') !== -1">余额管理</el-menu-item>
          <el-menu-item index="3-3" @click="toNewRouter('electronic-finance-pay-record')" v-if="permissionCodes.indexOf('013006000') !== -1">充值记录</el-menu-item>
          <el-menu-item index="3-4" @click="toNewRouter('electronic-finance-settlement-record')" v-if="permissionCodes.indexOf('013007000') !== -1">结算记录</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="7" v-if="permissionCodes.indexOf('013008000') !== -1 || permissionCodes.indexOf('013009000') !== -1 || permissionCodes.indexOf('013010000') !== -1 || permissionCodes.indexOf('013011000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_shuikongguanli"></i>
          <span>水控管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="7-1" @click="toNewRouter('water-finance-bill')" v-if="permissionCodes.indexOf('013008000') !== -1 ">账单管理</el-menu-item>
          <el-menu-item index="7-2" @click="toNewRouter('water-finance-rent-record')" v-if="permissionCodes.indexOf('013009000') !== -1">余额管理</el-menu-item>
          <el-menu-item index="7-3" @click="toNewRouter('water-finance-pay-record')" v-if="permissionCodes.indexOf('013010000') !== -1">充值记录</el-menu-item>
          <el-menu-item index="7-4" @click="toNewRouter('water-finance-settlement-record')" v-if="permissionCodes.indexOf('013011000') !== -1">结算记录</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
<!--      <el-submenu index="11" v-if="permissionCodes.indexOf('013020000') !== -1 || permissionCodes.indexOf('013021000') !== -1 || permissionCodes.indexOf('013022000') !== -1 || permissionCodes.indexOf('013023000') !== -1">-->
<!--        <template slot="title">-->
<!--          <i class="el-icon-damai-ic_zhengqiguanli"></i>-->
<!--          <span>蒸汽管理</span>-->
<!--        </template>-->
<!--        <el-menu-item-group>-->
<!--          <el-menu-item index="11-1" @click="toNewRouter('steam-finance-bill')" v-if="permissionCodes.indexOf('013020000') !== -1 ">账单管理</el-menu-item>-->
<!--          <el-menu-item index="11-2" @click="toNewRouter('steam-finance-rent-record')" v-if="permissionCodes.indexOf('013021000') !== -1">余额管理</el-menu-item>-->
<!--          <el-menu-item index="11-3" @click="toNewRouter('steam-finance-pay-record')" v-if="permissionCodes.indexOf('013022000') !== -1">充值记录</el-menu-item>-->
<!--          <el-menu-item index="11-4" @click="toNewRouter('steam-finance-settlement-record')" v-if="permissionCodes.indexOf('013023000') !== -1">结算记录</el-menu-item>-->
<!--        </el-menu-item-group>-->
<!--      </el-submenu>-->
<!--      <el-submenu index="12" v-if="permissionCodes.indexOf('013024000') !== -1 || permissionCodes.indexOf('013025000') !== -1 || permissionCodes.indexOf('013026000') !== -1 || permissionCodes.indexOf('013027000') !== -1">-->
<!--        <template slot="title">-->
<!--          <i class="el-icon-damai-ic_ranqiguanli"></i>-->
<!--          <span>燃气管理</span>-->
<!--        </template>-->
<!--        <el-menu-item-group>-->
<!--          <el-menu-item index="12-1" @click="toNewRouter('gas-finance-bill')" v-if="permissionCodes.indexOf('013024000') !== -1 ">账单管理</el-menu-item>-->
<!--          <el-menu-item index="12-2" @click="toNewRouter('gas-finance-rent-record')" v-if="permissionCodes.indexOf('013025000') !== -1">余额管理</el-menu-item>-->
<!--          <el-menu-item index="12-3" @click="toNewRouter('gas-finance-pay-record')" v-if="permissionCodes.indexOf('013026000') !== -1">充值记录</el-menu-item>-->
<!--          <el-menu-item index="12-4" @click="toNewRouter('gas-finance-settlement-record')" v-if="permissionCodes.indexOf('013027000') !== -1">结算记录</el-menu-item>-->
<!--        </el-menu-item-group>-->
<!--      </el-submenu>-->
      <el-submenu index="4" v-if="permissionCodes.indexOf('013012000') !== -1 || permissionCodes.indexOf('013013000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-jine"></i>
          <span>停车管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="4-1" @click="toNewRouter('parking-finance-monthly-payment')" v-if="permissionCodes.indexOf('013012000') !== -1">包月账单</el-menu-item>
          <el-menu-item index="4-2" @click="toNewRouter('parking-finance-temporary-stop')" v-if="permissionCodes.indexOf('013013000') !== -1">临停账单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="5" v-if="permissionCodes.indexOf('013014000') !== -1 || permissionCodes.indexOf('013015000') !== -1 || permissionCodes.indexOf('013016000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-wj-bxd"></i>
          <span>其他账单</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="5-1" @click="toNewRouter('place-booking-finance-pay-record')" v-if="permissionCodes.indexOf('013014000') !== -1">预约账单</el-menu-item>
          <el-menu-item index="5-2" @click="toNewRouter('repair-finance-pay-record')" v-if="permissionCodes.indexOf('013015000') !== -1">报修缴单</el-menu-item>
          <el-menu-item index="5-3" @click="toNewRouter('other-bill')" v-if="permissionCodes.indexOf('013016000') !== -1">其他费用账单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="14" v-if="permissionCodes.indexOf('013029000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_baobiaozhongxin"></i>
          <span>报表中心</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="14-1" @click="toNewRouter('tenant-list')" v-if="permissionCodes.indexOf('013029000') !== -1">租户账单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="8" v-if="permissionCodes.indexOf('013017000') !== -1 || permissionCodes.indexOf('013018000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-jiaofeijilu1"></i>
          <span>收费管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="8-1" @click="toNewRouter('contract-pay-record')" v-if="permissionCodes.indexOf('013017000') !== -1">收款管理</el-menu-item>
          <el-menu-item index="8-2" @click="toNewRouter('finance-refund')" v-if="permissionCodes.indexOf('013018000') !== -1">退款管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="10" @click="toNewRouter('finance-log')" v-if="permissionCodes.indexOf('013019000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!--<el-menu-item index="3" @click="toNewRouter('temperature')" >-->
        <!--<i class="el-icon-damai-icontw"></i>-->
        <!--<span slot="title">合同缴费记录</span>-->
      <!--</el-menu-item>-->
      <!--<el-menu-item index="3" @click="toNewRouter('temperature')" >-->
        <!--<i class="el-icon-damai-icontw"></i>-->
        <!--<span slot="title">电费缴费记录</span>-->
      <!--</el-menu-item>-->
      <!--<el-menu-item index="3" @click="toNewRouter('temperature')" >-->
        <!--<i class="el-icon-damai-icontw"></i>-->
        <!--<span slot="title">停车费缴费记录</span>-->
      <!--</el-menu-item>-->

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->


    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  '1': "finance-over-view",
  "2-1": ["rent-finance", "rent-finance-modify"],
  "2-2": ["property-finance", "property-finance-modify"],
  "2-3": ["deposit-finance", "deposit-finance-modify"],
  '3-1': "electronic-finance-bill",
  "3-2": "electronic-finance-rent-record",
  "3-3": "electronic-finance-pay-record",
  "3-4": "electronic-finance-settlement-record",
  "4-1": "parking-finance-monthly-payment",
  "4-2": "parking-finance-temporary-stop",
  '5-1': "place-booking-finance-pay-record",
  '5-2': "repair-finance-pay-record",
  '5-3': 'other-bill',
  '7-1': 'water-finance-bill',
  "7-2": "water-finance-rent-record",
  "7-3": "water-finance-pay-record",
  "7-4": "water-finance-settlement-record",
  '11-1': 'steam-finance-bill',
  "11-2": "steam-finance-rent-record",
  "11-3": "steam-finance-pay-record",
  "11-4": "steam-finance-settlement-record",
  '12-1': 'gas-finance-bill',
  "12-2": "gas-finance-rent-record",
  "12-3": "gas-finance-pay-record",
  "12-4": "gas-finance-settlement-record",
  '8-1': ["contract-pay-record", "add-contract-pay-record", "add-contract-pay-record-current", 'record-related-bills'],
  '8-2': ['finance-refund', 'add-finance-refund'],
  "9-1": ["other-rent-finance", "other-rent-finance-modify"],
  "13":"refund-bill-management",
  "14-1":["tenant-bill","tenant-list"],
  '10': ['finance-log']
});

export default {
  name: "phone-service-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      yqCode: "",
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/Finance/FinanceNav.vue